import { Emblem } from "../brand/Logo";

const WORDS = ["Crafted in Agra", "Returnable Glass", "Hotel Co-Branding", "Inspired by Hospitality", "A Statement on Every Table"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-serif-lux whitespace-nowrap px-8 text-5xl italic text-[#26231F] sm:text-7xl lg:text-[6.5rem]">{w}</span>
        <Emblem className="h-6 w-auto text-[#B18A4A] sm:h-8" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-hidden border-y border-[#B18A4A]/25 bg-[#F8F3E9] py-8 sm:py-10" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </div>
);
